/**
 * ========================================
 * Arcanum - Application Configuration
 * ========================================
 *
 * To change the app name, update the APP_NAME constant below.
 * All references throughout the app use this config.
 */

export const APP_NAME = 'Arcanum';
export const APP_DESCRIPTION = 'AI-Powered MCP Tools for SAP Development';
export const APP_TAGLINE = 'Unlock the power of AI for SAP with Model Context Protocol';

/**
 * Pricing configuration
 */
export const PRICING = {
    currency: 'USD',
    currencySymbol: 'US$',
    localCurrency: 'BRL',
    localCurrencySymbol: 'R$',
    exchangeRate: 5.0,
    plans: {
        abap: {
            id: 'mcp-abap',
            name: 'MCP ABAP',
            price: 100,
            localPrice: 500,
            interval: 'month' as const,
            descriptionKey: 'plans.abap.description',
            mcps: [
                { name: 'ABAP MCP', descriptionKey: 'plans.abap.mcps.abapMcp' },
                { name: 'ABAP Local Server', descriptionKey: 'plans.abap.mcps.localServer' },
                { name: 'ABAP Validator', descriptionKey: 'plans.abap.mcps.validator' },
            ],
            featureKeys: [
                'plans.abap.features.rap',
                'plans.abap.features.syntax',
                'plans.abap.features.adt',
                'plans.abap.features.codeGen',
            ],
            requiresSapConfig: true,
        },
        btp: {
            id: 'mcp-btp',
            name: 'MCPs BTP',
            price: 100,
            localPrice: 500,
            interval: 'month' as const,
            descriptionKey: 'plans.btp.description',
            mcps: [
                { name: 'CAP MCP', descriptionKey: 'plans.btp.mcps.cap' },
                { name: 'React MCP', descriptionKey: 'plans.btp.mcps.react' },
                { name: 'Fiori MCP', descriptionKey: 'plans.btp.mcps.fiori' },
                { name: 'HANA Cloud MCP', descriptionKey: 'plans.btp.mcps.hana' },
                { name: 'BTP Management MCP', descriptionKey: 'plans.btp.mcps.btpMgmt' },
            ],
            featureKeys: [
                'plans.btp.features.capScaffold',
                'plans.btp.features.reactGen',
                'plans.btp.features.fioriPatterns',
                'plans.btp.features.hanaQueries',
                'plans.btp.features.btpService',
            ],
            requiresSapConfig: false,
        },
    },
} as const;

/**
 * API Key configuration
 */
export const API_KEY_CONFIG = {
    maxKeysPerUser: 5,
    keyPrefix: 'arc_',
    keyLength: 32,
} as const;

/**
 * Routes
 */
export const ROUTES = {
    home: '/',
    login: '/login',
    register: '/register',
    dashboard: '/dashboard',
    setupGuide: '/setup',
    apiKeys: '/api-keys',
    sapEnvironments: '/sap-environments',
    profile: '/profile',
    purchase: '/purchase',
    adminUsers: '/admin/users',
    adminDomains: '/admin/domains',
} as const;
